/**
* Offset Hero JS
* -----------------------------------------------------------------------------
*
* All the JS for the Offset Hero component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
gsap.registerPlugin( ScrollTrigger );
( function( app ) {
  const COMPONENT = {

    className: 'offset-hero',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      let top = $( '.navbar' ).outerHeight();
      if ( $( '.logged-in' ).length ) {
        top += 32;
      }
      const tl = gsap.timeline( {
        scrollTrigger: {
          trigger: '.offset-hero',
          scrub: true,
          start: `top top+=${top}`,
          end: 'bottom top',
        },
      } );
      tl.to( '.offset-hero__scroll-shift', {x: '-600px'} );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'offset-hero', COMPONENT );
} )( app );
